import { Box, Link } from '@chakra-ui/react'
import React from 'react'

export default function ColdCuts() {
    return (
        <Box fontSize="lg" fontWeight="500"  lineHeight="50px">

            <Link>Sausages</Link>
            <br />
            <Link>Frankfurters</Link>
            <br />
            <Link>Lyoners</Link>
            <br />
            <Link>Salamis</Link>

        </Box>
    )
}
